/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device_GUZHANG': {
    width: 200,
    height: 191.76,
    viewBox: '0 0 1068 1024',
    data: '<path pid="0" _fill="#333" d="M1037.994 1024H28.054A28.054 28.054 0 010 995.946a28.054 28.054 0 0128.054-28.054h1009.94a28.054 28.054 0 0128.054 28.054 28.615 28.615 0 01-28.054 28.054zM836.006 756.366H240.14l73.502-261.462H749.6l86.406 261.462zM683.954 304.698H410.148l74.062-260.9h113.338l86.406 260.9z"/><path pid="1" _fill="#333" d="M954.393 1024H112.777L434.274 70.168A100.994 100.994 0 01533.024.033a102.677 102.677 0 0198.75 70.696zm-758.016-56.108h680.027l-296.25-879.77a47.692 47.692 0 00-90.333 0z"/>'
  }
})
